export class User {
  userId?: number;
  userName: string;
  password?: string;
  firstName: string;
  lastName: string;
  roleTypeCode: string;
  roleTypeDesc?: string;
  guid: string;
  emailAddress: string;
  loginHistoryId?: number;
  currentSessionId?: string;
  previousSessionId?: string;
  logoutReasonTypeCode?:string;
}
